// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.construction-cost-budget-table[data-v-d73b0180] {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.construction-cost-budget-table .budget-table-bottom[data-v-d73b0180] {
  height: calc(50% - 50px);
}
.construction-cost-budget-table .budget-table-bottom[data-v-d73b0180] > .content {
  height: 100%;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/views/BillPricingSoftware/ConstructionCostBudget/BudgetTable.vue","webpack://./BudgetTable.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;ACAF;ADLA;EAOI,wBAAA;ACCJ;ADRA;EASM,YAAA;EACA,gBAAA;ACEN","sourcesContent":["\n.construction-cost-budget-table {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  .budget-table-bottom {\n    height: calc(50% - 50px);\n    ::v-deep > .content {\n      height: 100%;\n      overflow: hidden;\n    }\n  }\n}\n",".construction-cost-budget-table {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n}\n.construction-cost-budget-table .budget-table-bottom {\n  height: calc(50% - 50px);\n}\n.construction-cost-budget-table .budget-table-bottom ::v-deep > .content {\n  height: 100%;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
